const translation = {
  Navigation: {
    Phone: "Telefon",
    Email: "Bizning elektron pocha",
    Quote: "Taklif",
    Home: "Uy",
    Services: "Xizmatlar",
    Why: "Nima uchun biz?",
    Who: "Biz kimmiz?",
    Contact: "Biz bilan bog'lanish",
    QuoteLast: "Taklif",
  },
  AboutArea: {
    aboutOurCompany: "Kompaniyamiz haqida",
    aboutOurCompanySubText: `MANINO TOZALASH VA KO’CHIRISH XIZMATI`,
    HassleFree: "Band insonlar uchun muammosiz tozalash va ko’chirish xizmati ",
    FreeConsultacy: "Manino ga qo’ng’iroq qiling",
    Mission: "Oliy maqsadimiz",
    MissionText: `Insonlar uchun toza muhit yaratish! Eng sifatli va ishonchli (sadoqatli) cleaning service berish. Toza muhit yaratgan holda odamlarning kayfiyatini ko'tarib ularning samaradorligini oshirishga yordam beramiz.`,
    MoreInfo: "Buyurtma Bering",
    Residential: "Uy-joylarni tozalash xizmatlari",
    ResidentialText: `Agar uyni tozalashga vaqtingiz kam bo'lsa, Manino servis jamoasi sizga yordam berishi mumkin. Uyingiz uchun takroriy tozalash xizmatlarini olishni o'ylab ko'rdingizmi? Bu xizmatimizning  foydalaridan hayratda qolishingizga ishonamiz. Oilangiz va do'stlaringiz bilan ko'proq vaqt o'tkazishingiz uchun sizning tozalash ehtiyojlaringiz va ish rejalaringizga mos keladigan hamyonbop tozalash xizmatimizni taklif qilamiz. Oilangizg uchun yanada toza va sog'lom muhit yarating.`,
    General: "Kundalik tozalash",
    Deep: "Mukammal Tozalash",
    MoveCleaning: "Ko'chish oldi va keyingi tozalash",
    CommercialCleaning: "Tijoriy tozalash",
    CommercialCleaningText: `Agar siz biznes bilan shug'ullansangiz, uni toza saqlash sog'lom ish muhitini yaratishda muhimdir, bu xodimlarga foyda keltiradi va biznesingizga yangi hamkorlar va mijozlarni jalb qilishga yordam beradi. Manino tijoriy tozalash xizmati biznes egalari va bino-inshoat boshqaruvchilariga qulaylik yaratadi. Manino tijoriy tozalash xizmatlari xodimlar va tashrif buyuruvchilar uchun sog'lom ichki muhitni yaratishga yordam beradi.`,
  },

  PopularServices: {
    subtitle: "Bizning mashhur xizmatlarimiz",
    title: "Bizning mashhur xizmatlarimiz",
    serviceItemOne: "Tijoriy tozalash",
    serviceItemTwo: "Uy-joylarni tozalash xizmatlari",
    serviceItemThere: "Takroriy tozalash xizmatlari",
    serviceItemFour: "Bir martalik tozalash",
    serviceItemFive: "Ko’chib kirishdan avvalgi tozalash xizmati",
    serviceItemSix: "Ko’chib chiqishdan keyingi tozalash xizmati",
    serviceItemOneInfo:
      "Manino professional tijoriy tozalash xizmatlarimiz sizning bo’sh vaqtingizni tejab sizga yanada muhimroq ishlar bilan shug’ullanishga imkoniyat yaratadi.",
    serviceItemTwoInfo:
      "Manino uylarini tozalash xizmatlari hayotingizni osonlashtirish va uyingizni yanada toza va sog'lom yashash joyiga aylantirish uchun mavjuddur.",
    serviceItemThereInfo:
      "Biz hammamiz ishonchli xizmatga muhtojmiz. Bizning haftalik, ikki haftalik yoki oylik tozalash xizmatlari hayot sifatini oshirish va toza uyga kirish quvonchini berish kabi bir qator afzalliklarni taklif qiladi!",
    serviceItemFourInfo:
      "Siz navbatdagi tozalash xizmatini Manino ga ishonib topshirishingiz mumkin. Bizga ishongan holda, siz tozalashga kamroq vaqt sarflashingiz va o'zingiz yoqtirgan narsalardan zavqlanishingiz mumkin.",
    serviceItemFiveInfo:
      "Yangi uyingizni tozalash uchun eng yaxshi vaqt - bu bo'sh bo'lgan paytda. Bizning ko'chishdan avvalgi tozalash xizmatimiz sizning ehtiyojlaringiz va byudjetingizga mos keladi.",
    serviceItemSixInfo:
      "Sobiq turar joyingizni ajoyib holatda tark etish Manino jamoasi bilan osonroq bo'ladi. Siz yangi joyingizni oʻzingiz xohlagan tarzda tartiblayotgan paytingizda, biz tozalash ishlarini bajaramiz.",
  },
  ChoseArea: {
    WhyHireUs: "Nima uchun bizni yollash kerak",
    ExpertHouse: "Mutaxassis uy tozalash xizmati ishonishi mumkin",
    EveryCustomer: `Har bir mijoz
      maxsus hisoblanadi`,
    EveryCustomerText: `Har bir mijoz o'ziga xosdir. Biz har bir mijozga alohida munosabatda bo'lamiz.
       Manino uchun hech qanday ish juda katta yoki kichik emas`,
    Quality: "Sifat",
    QualityText: `Yangi tozalangan uyga qaytishdan ko'ra yaxshiroq tuyg'u yo'q.
      Manino xizmatni amalga oshirganda, odamlar buni sezadilar. Sizni faxrlanishingizni istaymiz
      Sizning uyingiz va barcha tozalash ehtiyojlaringizni qondirish qobiliyatiga ishonchimiz komil.
        quam`,
    satisfaction: "To'lovlarda sizning qoniqishingiz muhim",
    setisfactionText: `Biz tashvishsiz xizmat ko'rsatishdan faxrlanamiz. Mijozlarimiz biz qilayotgan ishimizni yaxshi ko'radilar.
      Jamoamizning har bir a'zosi keng qamrovli tekshiruvdan va puxta tayyorgarlik jarayonidan o'tadi
      ishga qabul qilinganda va sizning himoyangiz uchun to'liq sug'urtalangan.
        quam`,
    BookAppointment: "Uchrashuvni onlayn bron qilish",
    BookAppointmentText: `Bizning yuqori interaktiv veb-saytimiz sizga keyingi tozalash xizmatini onlayn rejalashtirish imkonini beradi
        quam`,
    Trust: "Ishonch",
    TrustText: `Bizning mijozlarimiz o'z uylariga chinakam g'amxo'rlik qilishimizga ishonishlarini yaxshi ko'radilar.
        Agar siz Manio uy bekasi xizmatlarini so'rasangiz, bizdan doimo kutishingiz mumkin
        ochiq aloqa liniyasini saqlang, har bir ma'lumotga e'tibor bering,
        va sizning to'liq o'rnatishingizga sodiqligimizni ko'rsating
        quam`,
    WorryFree: "Xavotirsiz",
    WorryFreeText: `Biz tashvishsiz xizmat ko'rsatishdan faxrlanamiz. Bizning mijozlarimiz
        qilayotgan ishimizni yaxshi ko'ramiz. Jamoamizning har bir a'zosi katta sinovlardan o'tadi
        tekshirish va ishga qabul qilingandan keyin puxta o'quv jarayoni va sizning himoyangiz uchun to'liq sug'urtalangan.
        quam`,
  },
  Footer: {
    OurServices: "Bizning xizmatlar",
    Carpet: "Gilam tozalash",
    Plumbing: "Santexnika xizmatlari",
    ParkClear: "Park Cleaning",
    Residential: "Uy-joy xizmatlari",
    Copyright: "Copyright ©",
    AllRightsReserved: "All Rights Reserved",
    Apps: "EZ Apps",
  },
  Blogs: {
    SomeRecent: "Ba'zi so'nggi maqolalar",
    Work: "Kattaroq narsani yaratish uchun birgalikda ishlang",
  },
  CtaArea: {
    Online: "Onlayn uchrashuv",
    Service: "Xizmat nomi",
    Commercial: "Tijorat xizmati",
    Residential: "Uy-joy xizmati",
    Industrial: "Sanoat xizmati",
    CommercialLast: "Tijorat xizmati",
    ResidentialLast: "Residential Service",
    Submit: "Hozir yuboring",
  },
  PricingArea: {
    Affordable: "Our Affordable Package",
  },
  Special: "Maxsus narxlash paketi Yashirin to'lov",
  ProgressArea: {
    OurWork: "Bizning ish tajribamiz",
    FindStandart: "Shaxsiy teginish bilan standart tozalashni toping",
    DuisText: `Duis nunc sodales conubia yordam laoreet aliquet nostra
      eleifend lacinias prasent hendrerit quisque penatibus erat. Pulvinarda
      integer semper ridiculus lectuse condimentum obor tise verodar capmtaso morin
      proin nibh posuere.`,
    Repair: "Ta'mirlash sifati",
    Happy: "Baxtli mijoz",
    Support: "Qo'llab-quvvatlash markazi",
  },
  ProgressArea: {
    SomeCompleted: "Ba'zi Tugallangan Loyiha",
    EveryProject: "Har bir loyiha har xil, har bir mijoz uchun alohida",
  },
  Testimonial: {
    CustomerStatement: "Mijoz bayonoti",
    OurClient: "Our Client Feedback",
    Prev: "Oldingi",
    Next: "Keyingisi",
  },
  AboutSinglePrice: {
    CarpetCleaning: "Gilam tozalash",
    Bathroom: "Hammom tozalash",
    Floor: "Floor Cleaning",
    Bedroom: "Yotoq xonasini tozalash",
    Get: "Xizmatni oling",
  },
  AboutSingleTestimonial: {
    Erat: `Erat dapibus interdum consequat eleifend. Porttitor iaculis per lectus ornare dolor pede.
      Metus urna faucibus montes duis conds imentum congue. Accumsan bibendum pharetra a quisque nulla dictumst quam praesent
      pharetra cos apent sociosqu. Imperdiet matis sociosqu differ frome aliquam.Erat dapibus interdum consequat eleifend. Porttitor iaculis per lectus ornare dolor pede.
      Metus urna faucibus montes duis conds imentum congue. Accumsan bibendum pharetra a quisque nulla dictumst quam praesent
      pharetra cos apent sociosqu. Imperdiet mattis sociosqu bir xillikdan farq qiladi.`,
  },
  AppointmentSingleFeadback: {
    Hymenaeos: `Hymenaeos rhoncus proin aliquam justo sum mauris rutrum nulam semper purus rutru non sociis
        libero varius cumer to duine felis enisa porta ridiculus nisl acequis.`,
  },
  Breadcrumb: {
    Home: "Uy",
  },
  FaqSingleItem: {
    Edite: `Sociosqu felis quam ridiculus laoreet tempus, eleifend faucibus commodo uchun tahrirlash.
        Laoreet mauris congue sodales interdum lobortis proin laoreet quis arcu nostra et nam primis dolor
        sagittis duis laoreet, ultrices habitasse diam quisque in auctor porta metus viverra curae maecenas
        iaculis tempo pulvinar vitae dictum lorem ipsum orci.`,
  },
  HomeHeroSingleSlide: {
    TakeBack: "Bo’sh vaqtingizni qayta qo’lga kiriting! ",
    Orderyour: "Tozalash ",
    moving: "xizmatidan ",
    service: "foydalaning ",
    LearnMore: "Buyurtma Bering",
  },
  HomeHeroSingleSlide2: {
    TakeBack: "Bo’sh vaqtingizni qayta qo’lga kiriting! ",
    Orderyour: "Ko’chirish ",
    moving: "xizmatidan ",
    service: "foydalaning ",
    LearnMore: "Buyurtma Bering",
  },
  HeroSection: {
    subtitle: "Uy va biznes uchun premium xizmatlar",
    title: "Tozalash, ko'chirish va autsorsing endi oson",
    description:
      "Jadvalingizni bo'shating: Manino jamoasi tozalashni, ko'chirishni va kundalik vazifalarni o'z zimmasiga oladi.",
    primaryCta: "Buyurtma bering",
    secondaryCta: "Videoni ko'rish",
    cards: {
      cleaning: {
        title: "Tozalash",
        description:
          "Uylar va ofislar uchun muntazam hamda chuqur tozalash, ekologik vositalar bilan.",
        cta: "Tozalashni bron qiling",
      },
      moving: {
        title: "Ko'chirish",
        description:
          "Qadoqlash, transport va joylashtirishni qamrab olgan to'liq ko'chirish xizmati.",
        cta: "Ko'chishni rejalashtiring",
      },
      outsource: {
        title: "Autsorsing",
        description:
          "Resepshen, xizmat ko'rsatish va kundalik yordam uchun moslashuvchan mutaxassislar.",
        cta: "Qo'llab-quvvatlash buyurtma qiling",
      },
    },
  },
  HomeServiceItem: {
    Bras: `Bras fringilla conubia odios uira metus torquent commodo quam
        praesent torna pede`,
    GetQuote: "Taklif olish",
  },
  HomeSingleBlog: {
    HomeCleaning: "Uy tozalash",
    Continue: "O'qishni davom ettiring",
  },
  HomeSinglePrice: {
    Carpet: "Gilam tozalash",
    Bathroom: "Hammom tozalash",
    Floor: "Zaminni tozalash",
    Bedroom: "Yotoq xonasini tozalash",
  },
  HomeSingleProject: {
    Residential: "Uy-joy xizmati",
  },
  HomeSingleTestimonial: {
    EratText: `Erat dapibus interdum consequat eleifend. Porttitor iaculis per lectus ornare dolor pede.
         Metus urna faucibus montes duis conds imentum congue. Accumsan bibendum pharetra a quisque nulla dictumst
          quam praesent pharetra cos aptent sociosqu. Imperdiet mattis sociosqu differ frome aliquam.`,
  },
  HomeThreeHeroSlide: {
    Fast: "Tez va samarali xizmat",
    Cleaning: `Tozalash
        Zo'r
        Kafolatlangan!`,
    LearnMore: "Batafsil ma'lumot",
  },
  HomeThreeSIngleAbout: {
    Duis: `Duis congue atend lorem consequat interdum pretium ligula sempe`,
  },
  HomeThreeSIngleAbout: {
    ByJhon: "Jon Kardo tomonidan",
    Jun: "02 iyun - 2021 yil",
    Continue: "Continue Reading",
  },
  HomeThreeSingleChoseArea: {
    FacilsisText: `Facilsis veicula hendrerit turp turpis solutat neique dapibus justo rdiculu dapibus no ridicuy`,
  },
  HomeThreeSingleFeature: {
    Coingue:
      "Coingue aten lorem consqua interdum pretium ligaula a semper mauris easy dictuma",
  },
  HomeTwoCtaSingleItem: {
    Coingue:
      "Coingue atend lorem consequas interdum pretium ligula semper mauris is dictuma",
  },
  HomeTwoHeroSectionSingleSlide: {
    GetProfessional: "Professional bo'ling",
    CleaningServices: "Tozalash xizmatlari",
    CleanUp: "Clean up and see the change",
  },
  HomeTwoSingleFeature: {
    Duis: "Duis congue atend lorem consequat interdum pretium ligula",
  },
  ServicePageArea: {
    Buscipit: `Buscipit tincidunt duis antino gravidia nam tellusy
        nascetur neque vulpuits aenean scelerisque ultrces mushak massasi va moddalar tartibi umumiy`,
    LearnMore: "Batafsil ma'lumot",
  },
  ServiceTestimonial: {
    Hymenaeos: `Hymenaeos rhoncus proin aliquam justo sum mauris rutrum nulam semper purus rutru non sociis
        libero varius cumer to duine felis enisa porta ridiculus nisl acequis.`,
  },
  TeamSIngleBlog: {
    Aug: "avgust",
    Residential: "Aholi yashash joyi",
    Fementum: "Fementum pede commodo sceid gone malesua",
    Details: "Tafsilotlar Bu yerda",
  },
  Sidebar: {
    Home: "Uy",
    Services: "Xizmatlar",
    WhyHire: "Nima uchun bizni yollash kerak",
    WhoWe: "Biz kimmiz",
    ContactUs: "Biz bilan bog'lanish",
  },
  SingleAppointmentFeature: {
    Coingue:
      "Coingue aten lorem consqua interdum pretium ligaula a semper mauris easy dictuma",
  },
  SpecialSinglePricingPackage: {
    Carpet: "Gilam tozalash",
    Bathroom: "Hammom tozalash",
    Floor: "Zaminni tozalash",
    Bedroom: "Yotoq xonasini tozalash",
  },
  Quote: {
    GetYour: "Buyurtma bering",
    Form: "Shakl",
    select: "Tanlang",
    numberOfRooms: "Xonalar soni",
    numberOfRoomsPh: "Xonalar sonini kiriting",
    fullName: "To‘liq ism",
    fullNamePh: "To‘liq ismingizni kiriting",
    address: "Manzil",
    addressPh: "Manzilingizni kiriting",
    phone: "Telefon",
    submit: "Yuborish",
    district: {
      label: "Toshkent tumanini tanlang",
      placeholder: "Toshkent tumanini tanlang",
      items: {
        bektemir: "Bektemir",
        chilonzor: "Chilonzor",
        yashnobod: "Yashnobod",
        mirobod: "Mirobod",
        mirzoUlugbek: "Mirzo Ulug‘bek",
        olmazor: "Olmazor",
        sergeli: "Sergeli",
        shayxontohur: "Shayxontohur",
        uchtepa: "Uchtepa",
        yakkasaroy: "Yakkasaroy",
        yangihayot: "Yangihayot",
      },
    },
    InputTitle: {
      firstName: "Ism",
      lastName: "Familiya",
      email: "Email",
      next: "Keyingisi",
      back: "Orqaga",
      address: "Manzil",
      state: "Davlat",
      city: "Shaxar",
      zipCode: "Pochta indeksi",
      suit: "Kvartira",
    },
    FormTitle: {
      ServicesPosition: "Xizmat turini tanlang",
      ServicesType: "Xizmat turini tanlang",
      ServicesPlan: "Xizmat turini tanlang",
      Premises: "Obyetkning umumiy maydoni",
      AdditionalServices: "Qo'shimcha xizmatlar",
      Time: "Siz uchun qulay vaqt oralig’ini tanlang",
      ClientInfo: "Siz haqingizda",
      Salary: "Sizning Toza Hudud Tarifingiz",
      Location: "Manzil",
      Recomendation:
        "Birinchi marta tozalash har doim – mukammal tozalashdir. Agar haftalik yoki oylik tariflarimizdan birini tanlasangiz, ikkinchi tashrifdan boshlab 20% chegirma amal qiladi.",
    },
    ServicesPosition: {
      residential: {
        generial: "Kundalik tozalash",
        deep: "Mukammal Tozalash",
        movie: "Ko'chish oldi va keyingi tozalash",
        postConstruction: "Qurilishdan keyingi tozalash",
      },
      commercial: {
        generial: "Kundalik tozalash",
        deep: "Mukammal Tozalash",
        movie: "Ko'chish oldi va keyingi tozalash",
      },
      postConstruction: {
        residential: "Turar-joy",
        commercial: "Tijoriy",
      },
      moving: {
        residential: "Turar-joy",
        commercial: "Turar-joy",
      },
    },
    ServicesType: {
      residential: "Turar-joy tozalash",
      commercial: "Tijoriy tozalash",
      moving: "Ko’chirish",
    },
    ServicesPlan: {
      week2: "Haftada 2 marta",
      week1: "Haftada 1 marta",
      month2: "Oyda 2 marta",
      month1: "Oyda 1 marta",
      cleaningOne: "Bir marta tozalash",
    },
    AdditionalServices: {
      insideFridge: "Sovutgichning ichki qismini tozalash",
      insideOven: "Gaz plitalarning ichki qismlarini tozash",
      interiorWindows: "Ichki oynalarni tozalash",
      dishwashing: "Idish-tovoq yuvish (soat)",
      furniture: "Yumshoq mebellarni quruq tozalash (soat)",
      carpet: "Gilamlarni quruq tozalash (soat)",
    },
    Premises: {
      insideFridge: "Sovutgichlar soni",
      insideOven: "Gaz plitalar soni",
      interiorWindows: "Ichki oynalar yuzasi",
      dishwashing: "Qancha vaqt (soatda)",
      furniture: "Qancha vaqt (soatda)",
      carpet: "Qancha vaqt (soatda)",
    },
    Salary: {
      subtitle:
        "Xavotirga o’rin yo’q – istalgan paytda o’zgartirish yoki bekor qilish mumkin ",
      surfaceTitle: "Umumiy yuzasi",
      salaryTitle: "Birinchi tozalash jami",
      salarySubtitle:
        "Agar davomli tozalash xizmatiga a’zo bo’lsangiz, ikkinchi tozlashdan boshlab 20% skidkali xizmat olasiz. ",
      servicesTitle: "Xizmat turi",
      size: "yoki",
      price: "Narx",
      test: "Yuzasi",
      time: "Belgilangan-vaqt",
    },
    endPage: {
      title: "Bizga ishonganingiz uchun raxmat!",
      subtitle: "Biz sizga xizmat ko'rsatayotganimizdan mamnunmiz!",
      resTitle:
        "Tabriklaymiz siz buyurtmani faollashtirdingiz tez orada siz bilan bog'lanishadi!",
      btnToHome: "Uy",
      btn: "Yuborish",
    },
  },
};

export default translation;
